/**
 * Bullet Feedback Component
 *
 * Shows a Before / After rewrite suggestion for a single CV bullet point.
 *
 * Layout:
 *   Before: "Managed team of developers"
 *   After:  "Led cross-functional team of 12 engineers, delivering 3 products on time"
 *   Reason: Add metrics and specifics
 */

import React from 'react';
import { ArrowRight } from 'lucide-react';
import type { BulletFeedbackProps } from '../types';

export const BulletFeedback: React.FC<BulletFeedbackProps> = ({
  original,
  rewritten,
  reason,
}) => {
  return (
    <div className="ats-report-bullet">
      {/* Before */}
      <div className="ats-report-bullet__row ats-report-bullet__row--before">
        <span className="ats-report-bullet__label">Before</span>
        <span className="ats-report-bullet__text">{original}</span>
      </div>

      {/* Arrow separator */}
      <div className="ats-report-bullet__arrow">
        <ArrowRight className="ats-report-bullet__arrow-icon" />
      </div>

      {/* After */}
      <div className="ats-report-bullet__row ats-report-bullet__row--after">
        <span className="ats-report-bullet__label">After</span>
        <span className="ats-report-bullet__text">{rewritten}</span>
      </div>

      {/* Reason */}
      {reason && (
        <div className="ats-report-bullet__reason">
          <span className="ats-report-bullet__reason-label">Why:</span> {reason}
        </div>
      )}
    </div>
  );
};

BulletFeedback.displayName = 'BulletFeedback';

export default BulletFeedback;
